import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'
import { deviceType } from '@/util/base'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面 预约期 官网先展示预约
    {
      path: '/',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/home',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/home/m',
      component: () => import('./views/gw/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/news',
      component: () => import('./views/gw/news.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/news/m',
      component: () => import('./views/gw/news.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/content',
      component: () => import('./views/gw/content.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/content/m',
      component: () => import('./views/gw/content.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 다운로드하면 한정 탈것 & 날개 수령',
        keywords:
          '라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG  <라그나로크: 트와일라잇> 그랜드 오픈! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/FB',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/FB/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/GG',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/GG/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/TT',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    {
      path: '/pre/TT/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      }
    },
    // 下载
    {
      path: '/down/:version',
      meta: {
        title: '라그나로크: 트와일라잇 - 사전예약 등록하면 한정 탈것 & 날개 수령',
        keywords:
          ' 라그나로크: 트와일라잇,라그나로크,사전예약,RO,ROTW,ROO,ROX,ROM,ROR,ROMC,ROtwilight,Ragnarok Twilight,방치형RPG,방치형게임,MMORPG,보스변신,히어로변신,바포메트,포링,100%드롭,아이템폭발,폭발적파밍,혜자게임,무과금추천,양세찬게임,초고속성장,미드가르드,그라비티,GRAVITY,라그나로크온라인,추억의게임,클래식,메이플스토리,원신,명조,붕괴스타레일,인기무료게임,애니메이션풍,제니,Zeny,길드전,GVG,PVP,던전,레이드,네이버게임라운지,아이폰17프로이벤트,닌텐도스위치2,문화상품권',
        description:
          'RO 열대급 파밍, 히어로 어드벤처 RPG <라그나로크: 트와일라잇> 사전예약 중! 지금 예약하고 한정판 탈것, 코스튬 & 날개를 획득하세요! 추첨을 통해 아이폰 17 Pro, 문화상품권 및 굿즈까지 증정! MVP 처치 시 ‘짜릿한 아이템 폭발’, 방치만 해도 쉽고 빠르게 강해진다! 최초로 도입된 ‘영웅 변신 시스템’으로 바포메트 등 전설의 MVP로 직접 변신해 보세요!'
      },
      component: () => import('./views/down/index.vue')
    },
    // 404
    {
      path: '/:pathMatch(.*)*',
      component: () => import('../../components/404.vue')
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/]

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path))

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next()
    return
  }

  const isWap = deviceType() == 'wap'

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, '')
  let wapPath = pcPath.endsWith('/') ? `${pcPath}m` : `${pcPath}/m`

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith('/m')) {
    next({ path: wapPath, query: to.query })
  } else if (!isWap && to.path.endsWith('/m')) {
    next({ path: pcPath, query: to.query })
  } else {
    next()
  }
})

export default router
